import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

const FilersResultRow = ({ row }) => (
  <Fragment>
    <span dangerouslySetInnerHTML={{ __html: row.name }} />
    <br />
    <em>({row.type})</em>
    {row.date_added &&
      <div>
        Added: {row.date_added}
      </div>
    }
    {row.date_terminated &&
      <div>
        Added: {row.date_terminated}
      </div>
    }
  </Fragment>
);

FilersResultRow.propTypes = {
  row: PropTypes.any.isRequired,
};

export default FilersResultRow;



// WEBPACK FOOTER //
// ./src/components/advancedSearch/results/rows/FilersResultRow.jsx